<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <div class="col-md-12">
        <v-row class="pa-2 justify-space-between" no-gutters>
          <v-col
            v-for="(item, i) in icons"
            :key="i"
            :class="
              !!computedValue.find((v) => v.name === item.name)
                ? 'hasBorder'
                : ''
            "
            class="qrBtn ma-2 pa-2"
            style="position: relative; max-width: 144px; min-width: 144px"
            @click="clickedItem(item)"
          >
            <v-checkbox
              v-model="computedValue"
              :value="item"
              class="py-0 my-0"
              style="position: absolute; z-index: 3; top: 0"
              success
              @click.stop
            />

            <v-img
              :src="item.icon"
              aspect-ratio="1"
              height="128"
              max-width="128"
            />
          </v-col>
        </v-row>
      </div>
    </template>
  </help-info-wrapper>
</template>

<script>
import HelpInfo from "../../pages/qrland/components/helpAcordion/HelpInfo.vue";
import HelpInfoWrapper from "../../pages/qrland/components/helpAcordion/HelpInfoWrapper.vue";
export default {
  name: "armsChooser",

  props: {
    value: Array,
  },
  components: { HelpInfo, HelpInfoWrapper },
  data() {
    return {
      helpData: [],
      serviceName: "Qrland",
      componentName: "armsChooser",
      icons: [
        {
          name: "ISO",
          icon: "/media/certificates/iso.webp",
          white: "/media/certificates/isoWhite.svg",
          id: "1",
        },
        {
          name: this.$t('health_apple'),
          icon: "/media/certificates/sib.webp",
          white: "/media/certificates/sibWhite.svg",
          id: "2",
        },
        {
          name: this.$t('standard'),
          icon: "/media/certificates/Arm.webp",
          white: "/media/certificates/ArmWhite.svg",
          id: "3",
        },
        {
          name: this.$t('arshia_badge'),
          icon: "/media/certificates/Layer_1.webp",
          white: "",
          id: "4",
        },
        {
          name: this.$t('home_appliances_association'),
          icon: "/media/certificates/Layer_1_(1).webp",
          white: "",
          id: "5",
        },
        {
          name: this.$t('energy_label'),
          icon: "/media/certificates/Layer_1_(2).webp",
          white: "",
          id: "6",
        },
        {
          name: "ISO 17025",
          icon: "/media/certificates/Layer_1_(3).webp",
          white: "",
          id: "7",
        },
        {
          name: "ICR",
          icon: "/media/certificates/Layer_1_(4).webp",
          white: "",
          id: "8",
        },
        {
          name: "ISO 9001",
          icon: "/media/certificates/Layer_1_(5).webp",
          white: "",
          id: "9",
        },
      ],
      socialMedia: [],
    };
  },

  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },

  methods: {
    clickedItem(item) {
      let i = this.computedValue.findIndex((v) => v.name === item.name);

      if (i >= 0) this.computedValue.splice(i, 1);
      else this.computedValue.push(item);
    },
  },
};
</script>

<style scoped>
.qrBtn {
  border-radius: 4px !important;
  box-shadow: 4px 3px 5px rgba(2, 16, 92, 0.3);
  cursor: pointer;
  transition: all 0.15s ease-in-out;
}

.qrBtn:hover {
  border-radius: 8px !important;
  box-shadow: 8px 5px 10px #02105c8c !important;
}

.hasBorder {
  border: 2px solid green;
}
</style>
